const accuracyValidationKind = {
    standard: 'Standard',
    core: 'Core',
};

export default accuracyValidationKind;
